import styled from '@emotion/styled';
import BaseButton from './BaseButton';

const PrimaryOutlineButton = styled(BaseButton)`
    color: ${(props) => props.theme.highlightColor};    
    border-color: ${(props) => props.theme.highlightColor};
    
    &:hover {
        background: ${(props) => props.theme.highlightColor};
        color: ${props => props.theme.secondaryFontColor};
    }
`

export default PrimaryOutlineButton;
